// extracted by mini-css-extract-plugin
module.exports = {"AppCodeCard":"AppCodeCard_uQLFx","AppCodeCardCopyIcon":"AppCodeCardCopyIcon_wodQx","AppCodeCardCol":"AppCodeCardCol_jAlIz"};